export type LangCode = 'en' | 'hi' | 'gu';
export type Dict = Record<string, string>;

export const TRANSLATIONS: Record<LangCode, Dict> = {
  en: {
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    blog: 'Blog',
    support: 'Support',
    contact: 'Contact Us',
    registerLogin: 'Register / Login',
    language: 'Language',
    viewMore: 'View More',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    login: 'Login',
    register: 'Register',
    downloadApp: 'Download App',
    pricing: 'Pricing',
    faq: 'FAQ',
    privacy: 'Privacy',
    terms: 'Terms',
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    accountDeletion: 'Account Deletion',
    product: 'Product',
    company: 'Company',
    legal: 'Legal',
    quickLinks: 'Quick Links',
    help: 'Help',
    allRights: 'All rights reserved.',
    comingSoon: 'Coming Soon',
    pillarsEyebrow: 'Who We Are',
    purposeEyebrow: 'Purpose',
    pillarsTitle: 'Mission, vision & values',
    pillarsText: 'Empowering Everyone to Manage Personal Money with Confidence',
    digitalKhata: 'Digital Khata',
    addressCity: 'A-611 SIGNATURE-2, SARKHEJ SANAND HIGHWAY, Sarkhej, Daskroi, Ahmedabad - 382210, Gujarat',

    slide1Title: 'The Smartest Way to Manage Your Personal Credit & Debit Records',
    slide1Subtitle: 'Track Every Jama & Udhar with VEVAROK',
    slide1Text: 'VEVAROK is an AI-powered Digital Khata and Personal Credit Debit App that helps you record money given, money received, daily expenses, and pending payments in one secure place. Replace paper notebooks with smart reminders, reports, and voice entry.',
    slide1Cta: 'Start Free',
    webBase: 'Web Base',
    slide1Badge: 'Encrypted Ledger',
    slide1PhoneLabel: 'Good evening',
    slide1FloatATitle: 'Credit Entry',
    slide1FloatASub: '+₹4,500 · Aarav',
    slide1FloatBTitle: 'Debit Due',
    slide1FloatBSub: '₹2,800 · Tomorrow',
    slide1FloatCTitle: 'Reminder',
    slide1FloatCSub: 'Settle with Priya',
    slide1FloatDTitle: 'Analytics',
    slide1FloatDSub: '+18% this month',
    slide1Row1: 'Neha · Credit',
    slide1Row2: 'Rent · Debit',
    credit: 'Credit',
    debit: 'Debit',

    slide2Title: 'Track Every Customer, Friend & Family Account with Detailed Reports',
    slide2Text: 'View complete transaction history, outstanding balances, payment reminders, collections, and downloadable reports for every person. Stay organized with real-time account summaries and never lose track of your Jama or Udhar.',
    slide2Cta: 'Explore Services',
    slide2Badge: 'Smart Reports',
    slide2PhoneLabel: 'Outstanding',
    slide2FloatATitle: 'Party Report',
    slide2FloatASub: '42 parties active',
    slide2FloatBTitle: 'Collection',
    slide2FloatBSub: '₹18,200 today',
    slide2FloatCTitle: 'Reminder',
    slide2FloatCSub: '5 dues pending',
    slide2FloatDTitle: 'Growth',
    slide2FloatDSub: '+24% collections',
    slide2Row1: 'Ramesh Traders',
    slide2Row2: 'Kiran Store',

    slide3Title: 'One Account. Android, iPhone & Web—Always in Sync',
    slide3Text: 'Manage your complete personal ledger from any device. Access secure cloud-synced records anytime, anywhere, with real-time updates across Android, iOS, and Web.',
    slide3Cta: 'Create Account',
    slide3Badge: 'Multi Platform',
    slide3PhoneLabel: 'Synced & Secure',
    slide3FloatATitle: 'Secure Shield',
    slide3FloatASub: 'Bank-grade privacy',
    slide3FloatBTitle: 'Web Access',
    slide3FloatBSub: 'vevarok.com',
    slide3FloatCTitle: 'App Store',
    slide3FloatCSub: 'iOS ready',
    slide3FloatDTitle: 'Play Store',
    slide3FloatDSub: 'Android ready',
    slide3Row1: 'Cloud Sync',
    slide3Row2: 'Devices',

    heroBrand: 'VEVAROK · Softwagon Technologies',
    seeServices: 'Our Services',
    encrypted: 'Encrypted',
    multiLang: 'EN · HI · GU',
    multiPlatform: 'Android · iOS · Web',

    aboutEyebrow: 'About Us',
    aboutTitle: 'Making Personal Credit & Debit Management Simple, Smart & Secure',
    aboutBody: 'VEVAROK, a product of Softwagon Technologies Pvt. Ltd., was launched in 2026 with the vision of making personal Credit & Debit management easier for everyone. Whether you\'re tracking Jama, Udhar, money lent to friends, family transactions, or daily personal expenses, VEVAROK helps you keep everything organized in one secure Digital Khata.',
    aboutLi1: 'Easily record Personal Credit & Debit transactions',
    aboutLi2: 'Track Jama, Udhar & Daily Personal Hisab',
    aboutLi3: 'AI Voice Entry for faster transaction recording',
    aboutLi4: 'Smart Payment Reminder Notifications',
    aboutLi5: 'Party-wise Transaction History & Balance Reports',
    aboutLi6: 'Available on Android, iOS & Web',

    getAppEyebrow: 'Get the App',
    getAppTitle: 'Download VEVAROK anywhere',
    getAppText: 'Manage your Personal Credit & Debit, customer accounts, daily expenses, and payment records from any device. Stay connected with Android, iOS, and Web using secure cloud synchronization.',
    getOn: 'GET IT ON',
    googlePlay: 'Google Play',
    downloadOn: 'Download on the',
    appStore: 'App Store',
    alsoOn: 'Also available on',
    webApp: 'Web App',

    whyEyebrow: 'Why Choose Us',
    whyTitle: 'Digital Financial Record',
    whyText: 'Manage all your Jama, Udhar, Credit, and Debit transactions in one secure place with an intelligent digital ledger designed for everyday use.',
    why1Title: 'Bank-grade Security',
    why1Desc: 'Encrypted ledger entries with complete privacy for your business data.',
    why2Title: 'Credit Clarity',
    why2Desc: 'Know who owes you and how much — in one clear glance.',
    why3Title: 'Debit Control',
    why3Desc: 'Track what you owe suppliers and customers with calm reminders.',
    why4Title: 'Living Insights',
    why4Desc: 'Smart analytics that help you grow collections and reduce dues.',

    showcaseEyebrow: 'AI Powered Khata',
    showcaseTitle: 'Speak your entry — AI understands instantly',
    showcaseText: 'VEVAROK Smart AI Assist listens to your voice, recognises amounts, and updates your credit-debit ledger in seconds.',
    showcaseLi1: 'AI Voice Entry — add credit & debit by speaking',
    showcaseLi2: 'Smart AI Assist — party, amount, notes auto-filled',
    showcaseLi3: 'Hindi, English & Gujarati voice support',
    aiVoiceTitle: 'AI Voice Entry',
    aiVoiceDesc: 'Add credit & debit by speaking — AI instantly understands amount, name, and notes.',
    smartAiTitle: 'Smart AI Assist',
    smartAiDesc: 'After voice input, AI auto-fills party, amount, and reminders — almost zero typing.',
    listening: 'Listening…',
    aiParsed: 'AI Parsed',
    voice: 'Voice',
    ai: 'AI',
    happyUsers: 'Happy Users',
    entriesTracked: 'Entries Tracked',
    appRating: 'App Rating',

    experienceEyebrow: 'Experience VEVAROK',
    personTitle: 'Your digital khata companion',
    personText: 'Experience a smarter way to manage your daily finances with VEVAROK. Replace traditional paper account books with a modern Digital Khata that keeps every credit, debit, and payment record organized in one secure place. Use AI Voice Entry for faster transaction recording, monitor outstanding balances with Party-wise Reports, automate payment reminders, and securely access your data anytime with cloud synchronization. Whether you\'re at home, in your shop, or on the move, VEVAROK ensures your complete Hisab Kitab is always accurate and accessible.',

    servicesEyebrow: 'Services',
    servicesTitle: 'All-in-One Digital Khata for Everyday Money Management',
    servicesText: 'Built to help you record, track, and manage every Credit & Debit transaction effortlessly.',
    svc1Title: 'Credit Entries',
    svc1Desc: 'Log and settle customer credits with notes and dates.',
    svc2Title: 'Debit Entries',
    svc2Desc: 'Track dues to suppliers without mental clutter.',
    svc3Title: 'Reminders',
    svc3Desc: 'Timely alerts before important payment dates.',
    svc4Title: 'Reports',
    svc4Desc: 'Clear reports of your money flow and outstanding.',
    svc5Title: 'Secure Sync',
    svc5Desc: 'Phone + web, same private ledger always in sync.',
    svc6Title: 'Languages',
    svc6Desc: 'English, Hindi & Gujarati ready for every user.',

    reviewsEyebrow: 'Reviews',
    reviewsTitle: 'Trusted by Thousands for Everyday Personal Hisab',
    reviewsText: 'Keep your personal Jama, Udhar, and daily money records organized with a simple, secure, and smart Digital Khata.',
    rev1Text: 'Finally a khata app that feels premium. Tracking udhaar from customers has never been this easy.',
    rev1Name: 'Ananya S.',
    rev1Place: 'Ahmedabad',
    rev2Text: 'The reminders actually help me collect on time. My outstanding has dropped significantly.',
    rev2Name: 'Rahul M.',
    rev2Place: 'Mumbai',
    rev3Text: 'Crystal clear design. I enjoy checking my shop ledger every morning now.',
    rev3Name: 'Priya N.',
    rev3Place: 'Surat',
    rev4Text: 'International quality app — built perfectly for Indian shopkeepers and traders.',
    rev4Name: 'Karan P.',
    rev4Place: 'Pune',

    blogEyebrow: 'Our Latest Blog',
    blogTitle: 'Guides for smarter bookkeeping',
    blogText: 'Short reads on credit, debit, collections, and business growth.',
    blog1Title: '5 habits for healthier business credit',
    blog1Meta: '4 min read',
    blog1Tag: 'Tips',
    blog2Title: 'How to track udhaar without stress',
    blog2Meta: '5 min read',
    blog2Tag: 'Guides',
    blog3Title: 'Why security matters in khata apps',
    blog3Meta: '6 min read',
    blog3Tag: 'Trust',
    readMore: 'Read more',

    ctaTitle: 'Ready to Simplify Your Daily Hisab?',
    ctaText: 'Record every transaction, track balances, and never forget a payment with VEVAROK\'s AI-powered Digital Khata.',
    createAccount: 'Create free account',
    talkToUs: 'Talk to us',
    liveSupportFab: 'Live Support',
    liveSupportTitle: 'VEVAROK Live Support',
    liveSupportOnline: 'Online now',
    liveSupportText: 'Need help with your Digital Khata? Chat with us instantly or reach our Softwagon team.',
    liveSupportWhatsapp: 'WhatsApp Chat',
    liveSupportWhatsappSub: 'Quick replies on WhatsApp',
    liveSupportCall: 'Call Support',
    liveSupportEmail: 'Email Us',
    liveSupportForm: 'Contact Form',
    liveSupportFormSub: 'Send a detailed message',

    footerAbout: 'Digital khata for shopkeepers and traders — premium, secure, and beautifully simple. A brand of Softwagon Technologies Pvt. Ltd.',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',

    aboutPageEyebrow: 'About Us',
    aboutPageTitle: 'VEVAROK – Your Personal Digital Khata by Softwagon Technologies',
    aboutPageSub: 'VEVAROK is an AI-powered Personal Credit & Debit App designed to simplify Jama, Udhar, daily expenses, and personal Hisab. With Digital Khata, AI Voice Entry, payment reminders, and secure cloud backup, VEVAROK helps you keep every personal transaction organized, accurate, and accessible anytime.',
    aboutIntroTitle: 'Making Personal Credit & Debit Management Simple, Smart & Secure',
    aboutIntroP1: 'VEVAROK, a product of Softwagon Technologies Pvt. Ltd. was launched in 2026 with the vision of making personal Credit & Debit management easier for everyone. Whether you\'re tracking Jama, Udhar, money lent to friends, family transactions, or daily personal expenses, VEVAROK helps you keep everything organized in one secure Digital Khata.',
    aboutIntroP2: 'With intelligent features like AI Voice Entry, Smart Payment Reminders, Party-wise Transaction History, and Cloud Backup, managing your daily Hisab becomes faster, more accurate, and completely paperless. Available on Android, iPhone, and Web, VEVAROK ensures your personal financial records are always accessible, secure, and up to date.',
    missionTitle: 'Our Mission',
    missionText: 'Our mission is to help people manage personal Credit, Debit, Jama, Udhar, and daily financial records with confidence through an easy-to-use Digital Khata. We aim to simplify everyday money tracking with AI-powered features, secure cloud storage, and smart payment reminders.',
    visionTitle: 'Our Vision',
    visionText: 'Our vision is to become the preferred Personal Credit & Debit App for individuals by providing a secure, intelligent, and reliable platform that makes managing personal money records simple, accurate, and completely paperless.',
    valuesTitle: 'Our Values',
    valuesText: 'Every feature in VEVAROK is built around the values of trust, privacy, simplicity, and innovation. We are dedicated to creating a secure Digital Khata that helps users manage their personal financial records with confidence while delivering an intuitive experience powered by modern technology.',
    benefitsEyebrow: 'Benefits',
    benefitsTitle: 'Why Choose VEVAROK for Your Daily Personal Hisab',
    benefitsText: 'Manage your Jama, Udhar, Credit, and Debit with confidence. VEVAROK combines AI-powered features, secure cloud storage, and an intuitive Digital Khata to make personal money management simple, organized, and stress-free.',
    benefit1: 'Track Personal Credit & Debit with complete clarity',
    benefit2: 'Secure Digital Khata for every Jama & Udhar record',
    benefit3: 'Never miss a payment with smart reminders',
    benefit4: 'View complete personal transaction history & reports',
    benefit5: 'Sync across Android, iPhone & Web anytime',
    benefit6: 'Use VEVAROK in English, Hindi & Gujarati',

    servicesPageEyebrow: 'Our Services',
    servicesPageTitle: 'Smart Features for Effortless Personal Credit & Debit Management',
    servicesPageSub: 'VEVAROK helps you manage Jama, Udhar, personal Credit & Debit, daily expenses, and payment reminders with an AI-powered Digital Khata. Explore powerful features designed to simplify your everyday personal money management.',
    svc7Title: 'Entry History',
    svc7Desc: 'Search past settlements and revisit every business transaction.',
    svc8Title: 'Privacy Controls',
    svc8Desc: 'Your data stays protected with encryption-first design.',
    svc9Title: 'Multi-Device Access',
    svc9Desc: 'Switch seamlessly between Android, iPhone, and Web while keeping your data synchronized.',
    svc10Title: 'Digital Money Diary',
    svc10Desc: 'Keep all your personal money records organized in one secure Digital Khata, accessible anytime.',

    contactPageEyebrow: 'Contact Us',
    contactPageTitle: "Let's talk",
    contactPageSub: 'Questions about digital khata on VEVAROK? We\'re listening.',
    contactDetails: 'Contact details',
    contactDetailsText: 'Reach our support team for product help, feedback, or partnership questions.',
    sendMessage: 'Send a message',
    fullName: 'Full Name',
    yourName: 'Your name',
    yourEmail: 'you@email.com',
    yourPhone: '+91 ...',
    message: 'Message',
    howCanHelp: 'How can we help?',
    sendBtn: 'Send Message',
    sendingBtn: 'Sending...',
    thankMsg: "Thank you! We'll get back to you soon.",
    contactSubmitError: 'Unable to send your message. Please try again.',
    captchaRequired: 'Please complete the CAPTCHA verification before sending.',
    captchaError: 'CAPTCHA verification failed. Please try again.',
    captchaLoadError: 'Unable to load CAPTCHA. Please refresh the page and try again.',
    captchaConfigError: 'CAPTCHA is not configured. Please contact the site administrator.',

    supportPageEyebrow: 'Support',
    supportPageTitle: "We're here to help",
    supportPageSub: 'Find quick answers about digital khata and credit & debit on VEVAROK.',
    faqTitle: 'Frequently Asked Questions',
    aboutFaqTitle: 'Find Answers About VEVAROK',
    faqText: 'Everything you need to know about managing your Personal Credit & Debit, Jama-Udhar, and Digital Khata with VEVAROK.',
    contactSupport: 'Contact Support',
    faq1Q: 'What is VEVAROK?',
    faq1A: 'VEVAROK is an AI-powered Personal Credit & Debit App that helps you manage Jama, Udhar, daily expenses, and personal money records in one secure Digital Khata.',
    faq2Q: 'Who can use VEVAROK?',
    faq2A: 'VEVAROK is designed for anyone who wants to manage personal financial records, including friends, family members, roommates, and individuals who regularly track money they give or receive.',
    faq3Q: 'Can I record transactions using my voice?',
    faq3A: 'Yes. VEVAROK includes AI Voice Entry, allowing you to record Credit & Debit transactions simply by speaking.',
    faq4Q: 'Can I access VEVAROK on multiple devices?',
    faq4A: 'Yes. You can securely access your Digital Khata from Android, iPhone, and Web, with your data synchronized across all devices.',
    faq5Q: 'Does VEVAROK support multiple languages?',
    faq5A: 'Yes. VEVAROK is available in English, Hindi, and Gujarati for a comfortable user experience.',
    faq6Q: 'How do I contact support?',
    faq6A: 'Visit the Contact Us page or email support@vevarok.com. Our Softwagon Technologies team is happy to help.',

    authRegisterTitle: 'Create your account',
    authRegisterText: 'Track credit & debit in one crystal-clear digital khata.',
    authLoginTitle: 'Welcome back',
    authLoginText: 'Access your credit & debit dashboard.',
    authForgotTitle: 'Reset password',
    authForgotText: "Enter your email and we'll send a one-time code to verify your identity.",
    authOtpTitle: 'Enter OTP',
    authOtpText: 'We sent a 4-digit code to your email. Enter it below to continue.',
    name: 'Full Name',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot password?',
    sendOtp: 'Send OTP',
    verify: 'Verify',
    alreadyHave: 'Already have an account?',
    noAccount: 'New to VEVAROK?',
    blogPageEyebrow: 'Blog',
    blogPageTitle: 'Our Latest Articles',
    blogPageSub: 'Practical guides for credit, debit, collections, and business growth.',
    blog4Title: 'Using reminders the smart way',
    blog4Meta: '4 min read',
    blog4Tag: 'Product',
    blog4Excerpt: 'Turn due-date alerts into a helpful money habit for better collections.',
    blog1Excerpt: 'Simple routines that keep your credit entries clear and stress-free.',
    blog2Excerpt: 'A calm approach to managing dues and payment dates.',
    blog3Excerpt: 'What encryption and privacy mean for your digital ledger.',
    readArticle: 'Read article',
    backToLogin: 'Back to sign in',
    secureSignIn: 'Secure Sign In',
    continueBtn: 'Continue',
    signIn: 'Sign In',
    createPassword: 'Create a strong password',
    yourPassword: 'Your password'
  },
  hi: {
    home: 'होम',
    about: 'हमारे बारे में',
    services: 'सेवाएँ',
    blog: 'ब्लॉग',
    support: 'सहायता',
    contact: 'संपर्क करें',
    registerLogin: 'रजिस्टर / लॉगिन',
    language: 'भाषा',
    viewMore: 'और देखें',
    getStarted: 'शुरू करें',
    learnMore: 'और जानें',
    login: 'लॉगिन',
    register: 'रजिस्टर',
    downloadApp: 'ऐप डाउनलोड',
    pricing: 'मूल्य',
    faq: 'सामान्य प्रश्न',
    privacy: 'गोपनीयता',
    terms: 'नियम',
    termsAndConditions: 'नियम और शर्तें',
    privacyPolicy: 'गोपनीयता नीति',
    accountDeletion: 'खाता हटाना',
    product: 'उत्पाद',
    company: 'कंपनी',
    legal: 'कानूनी',
    quickLinks: 'त्वरित लिंक',
    help: 'मदद',
    allRights: 'सर्वाधिकार सुरक्षित।',
    comingSoon: 'जल्द आ रहा है',
    pillarsEyebrow: 'हम कौन हैं',
    purposeEyebrow: 'उद्देश्य',
    pillarsTitle: 'मिशन, विज़न और मूल्य',
    pillarsText: 'हर किसी को आत्मविश्वास के साथ पर्सनल पैसे प्रबंधित करने में सशक्त बनाना',
    digitalKhata: 'डिजिटल खाता',
    addressCity: 'A-611 SIGNATURE-2, SARKHEJ SANAND HIGHWAY, Sarkhej, Daskroi, Ahmedabad - 382210, Gujarat',

    slide1Title: 'अपने व्यक्तिगत क्रेडिट और डेबिट रिकॉर्ड प्रबंधित करने का सबसे स्मार्ट तरीका',
    slide1Subtitle: 'VEVAROK के साथ हर जमा और उधार ट्रैक करें',
    slide1Text: 'VEVAROK एक AI-संचालित डिजिटल खाता और पर्सनल क्रेडिट-डेबिट ऐप है, जो आपको दिए गए पैसे, प्राप्त किए गए पैसे, दैनिक खर्च और बाकी भुगतान का रिकॉर्ड एक सुरक्षित स्थान पर रखने में मदद करता है। कागज़ की खाता-बही को अलविदा कहें और स्मार्ट रिमाइंडर, विस्तृत रिपोर्ट तथा AI वॉइस एंट्री के साथ अपने सभी लेन-देन को आसानी से प्रबंधित करें।',
    slide1Cta: 'मुफ़्त शुरू करें',
    webBase: 'वेब बेस',
    slide1Badge: 'एन्क्रिप्टेड खाता',
    slide1PhoneLabel: 'शुभ संध्या',
    slide1FloatATitle: 'क्रेडिट एंट्री',
    slide1FloatASub: '+₹4,500 · आरव',
    slide1FloatBTitle: 'डेबिट बकाया',
    slide1FloatBSub: '₹2,800 · कल',
    slide1FloatCTitle: 'रिमाइंडर',
    slide1FloatCSub: 'प्रिया से वसूली',
    slide1FloatDTitle: 'विश्लेषण',
    slide1FloatDSub: 'इस महीने +18%',
    slide1Row1: 'नेहा · क्रेडिट',
    slide1Row2: 'किराया · डेबिट',
    credit: 'क्रेडिट',
    debit: 'डेबिट',

    slide2Title: 'हर ग्राहक, मित्र और परिवार के खाते को विस्तृत रिपोर्ट के साथ ट्रैक करें',
    slide2Text: 'हर व्यक्ति के लेन-देन का पूरा रिकॉर्ड, बाकी राशि, पेमेंट रिमाइंडर, कलेक्शन विवरण और डाउनलोड करने योग्य रिपोर्ट आसानी से देखें। रियल-टाइम अकाउंट सारांश के साथ अपने जमा और उधार का हिसाब हमेशा सटीक और व्यवस्थित रखें।',
    slide2Cta: 'सेवाएँ देखें',
    slide2Badge: 'स्मार्ट रिपोर्ट',
    slide2PhoneLabel: 'बकाया',
    slide2FloatATitle: 'पार्टी रिपोर्ट',
    slide2FloatASub: '42 सक्रिय पार्टियाँ',
    slide2FloatBTitle: 'वसूली',
    slide2FloatBSub: 'आज ₹18,200',
    slide2FloatCTitle: 'रिमाइंडर',
    slide2FloatCSub: '5 बकाया लंबित',
    slide2FloatDTitle: 'वृद्धि',
    slide2FloatDSub: 'वसूली +24%',
    slide2Row1: 'रमेश ट्रेडर्स',
    slide2Row2: 'किरण स्टोर',

    slide3Title: 'एक खाता. Android, iPhone और Web—हमेशा सिंक में',
    slide3Text: 'किसी भी डिवाइस से अपना पूरा व्यक्तिगत खाता प्रबंधित करें। Android, iOS और Web पर रियल-टाइम अपडेट के साथ सुरक्षित क्लाउड-सिंक रिकॉर्ड कभी भी, कहीं भी एक्सेस करें।',
    slide3Cta: 'खाता बनाएँ',
    slide3Badge: 'मल्टी प्लेटफ़ॉर्म',
    slide3PhoneLabel: 'सिंक और सुरक्षित',
    slide3FloatATitle: 'सुरक्षा ढाल',
    slide3FloatASub: 'बैंक-स्तरीय गोपनीयता',
    slide3FloatBTitle: 'वेब एक्सेस',
    slide3FloatBSub: 'vevarok.com',
    slide3FloatCTitle: 'ऐप स्टोर',
    slide3FloatCSub: 'iOS तैयार',
    slide3FloatDTitle: 'प्ले स्टोर',
    slide3FloatDSub: 'Android तैयार',
    slide3Row1: 'क्लाउड सिंक',
    slide3Row2: 'डिवाइस',

    heroBrand: 'VEVAROK · Softwagon Technologies',
    seeServices: 'हमारी सेवाएँ',
    encrypted: 'एन्क्रिप्टेड',
    multiLang: 'EN · HI · GU',
    multiPlatform: 'Android · iOS · Web',

    aboutEyebrow: 'हमारे बारे में',
    aboutTitle: 'पर्सनल क्रेडिट और डेबिट प्रबंधन को सरल, स्मार्ट और सुरक्षित बनाना',
    aboutBody: 'VEVAROK, Softwagon Technologies Pvt. Ltd. का उत्पाद, 2026 में सभी के लिए पर्सनल क्रेडिट और डेबिट प्रबंधन आसान बनाने के विज़न के साथ लॉन्च हुआ। चाहे आप जमा, उधार, दोस्तों को उधार दिए पैसे, पारिवारिक लेन-देन या रोज़ाना व्यक्तिगत खर्च ट्रैक कर रहे हों — VEVAROK सब कुछ एक सुरक्षित डिजिटल खाते में व्यवस्थित रखने में मदद करता है।',
    aboutLi1: 'पर्सनल क्रेडिट और डेबिट लेन-देन आसानी से रिकॉर्ड करें',
    aboutLi2: 'जमा, उधार और रोज़ाना पर्सनल हिसाब ट्रैक करें',
    aboutLi3: 'तेज़ लेन-देन रिकॉर्डिंग के लिए AI वॉइस एंट्री',
    aboutLi4: 'स्मार्ट पेमेंट रिमाइंडर नोटिफ़िकेशन',
    aboutLi5: 'पार्टी-वार लेन-देन इतिहास और बैलेंस रिपोर्ट',
    aboutLi6: 'Android, iOS और Web पर उपलब्ध',

    getAppEyebrow: 'ऐप प्राप्त करें',
    getAppTitle: 'VEVAROK कहीं भी डाउनलोड करें',
    getAppText: 'किसी भी डिवाइस से अपना पर्सनल क्रेडिट और डेबिट, ग्राहक खाते, रोज़ाना खर्च और भुगतान रिकॉर्ड प्रबंधित करें। सुरक्षित क्लाउड सिंक के साथ Android, iOS और Web पर जुड़े रहें।',
    getOn: 'डाउनलोड करें',
    googlePlay: 'Google Play',
    downloadOn: 'डाउनलोड करें',
    appStore: 'App Store',
    alsoOn: 'यहाँ भी उपलब्ध',
    webApp: 'वेब ऐप',

    whyEyebrow: 'हमें क्यों चुनें',
    whyTitle: 'डिजिटल फाइनेंशियल रिकॉर्ड',
    whyText: 'अपने सभी जमा, उधार, क्रेडिट और डेबिट लेन-देन को एक सुरक्षित स्थान पर प्रबंधित करें। रोज़मर्रा के उपयोग के लिए डिज़ाइन की गई स्मार्ट डिजिटल खाता-बही के साथ अपने सभी हिसाब को आसान, सुरक्षित और व्यवस्थित रखें।',
    why1Title: 'बैंक-स्तरीय सुरक्षा',
    why1Desc: 'आपके व्यवसायिक डेटा के लिए पूर्ण गोपनीयता के साथ एन्क्रिप्टेड खाता एंट्री।',
    why2Title: 'क्रेडिट स्पष्टता',
    why2Desc: 'जानें किस पर कितना बकाया है — एक नज़र में।',
    why3Title: 'डेबिट नियंत्रण',
    why3Desc: 'सप्लायर और ग्राहकों के प्रति देय राशि को शांत रिमाइंडर के साथ ट्रैक करें।',
    why4Title: 'स्मार्ट विश्लेषण',
    why4Desc: 'ऐसे विश्लेषण जो वसूली बढ़ाने और बकाया कम करने में मदद करें।',

    showcaseEyebrow: 'AI संचालित खाता',
    showcaseTitle: 'बोलकर एंट्री करें — AI तुरंत समझे',
    showcaseText: 'VEVAROK AI स्मार्ट सहायक आपकी आवाज़ सुनता है, राशि पहचानता है और क्रेडिट-डेबिट खाता सेकंडों में अपडेट करता है।',
    showcaseLi1: 'AI वॉइस एंट्री — बोलकर क्रेडिट और डेबिट जोड़ें',
    showcaseLi2: 'AI स्मार्ट सहायक — पार्टी, राशि, नोट्स ऑटो-फिल',
    showcaseLi3: 'हिंदी, अंग्रेज़ी और गुजराती वॉयस सपोर्ट',
    aiVoiceTitle: 'AI वॉइस एंट्री',
    aiVoiceDesc: 'बोलकर क्रेडिट और डेबिट जोड़ें — AI तुरंत राशि, नाम और नोट्स समझता है।',
    smartAiTitle: 'AI स्मार्ट सहायक',
    smartAiDesc: 'वॉयस के बाद AI पार्टी, राशि और रिमाइंडर ऑटो-फिल करता है — लगभग बिना टाइपिंग।',
    listening: 'सुन रहा है…',
    aiParsed: 'AI पार्स किया',
    voice: 'वॉयस',
    ai: 'AI',
    happyUsers: 'खुश उपयोगकर्ता',
    entriesTracked: 'ट्रैक की गई एंट्री',
    appRating: 'ऐप रेटिंग',

    experienceEyebrow: 'VEVAROK अनुभव',
    personTitle: 'आपका डिजिटल खाता साथी',
    personText: 'VEVAROK के साथ अपने रोज़ाना के वित्त प्रबंधन का एक स्मार्ट तरीका अनुभव करें। पारंपरिक कागज़ी खातों की जगह आधुनिक डिजिटल खाता अपनाएँ जो हर क्रेडिट, डेबिट और भुगतान रिकॉर्ड को एक सुरक्षित जगह पर व्यवस्थित रखता है। तेज़ लेन-देन रिकॉर्डिंग के लिए AI वॉइस एंट्री का उपयोग करें, पार्टी-वार रिपोर्ट से बकाया बैलेंस मॉनिटर करें, पेमेंट रिमाइंडर ऑटोमेट करें, और क्लाउड सिंक के साथ कभी भी सुरक्षित रूप से अपने डेटा तक पहुँचें। चाहे आप घर पर हों, दुकान में हों या यात्रा में — VEVAROK सुनिश्चित करता है कि आपका पूरा हिसाब-किताब हमेशा सटीक और उपलब्ध रहे।',

    servicesEyebrow: 'सेवाएँ',
    servicesTitle: 'रोज़मर्रा के पैसे प्रबंधन के लिए ऑल-इन-वन डिजिटल खाता',
    servicesText: 'हर क्रेडिट और डेबिट लेन-देन को आसानी से रिकॉर्ड, ट्रैक और प्रबंधित करने में मदद के लिए बनाया गया।',
    svc1Title: 'क्रेडिट एंट्री',
    svc1Desc: 'नोट्स और तारीखों के साथ ग्राहक क्रेडिट दर्ज और निपटाएँ।',
    svc2Title: 'डेबिट एंट्री',
    svc2Desc: 'सप्लायर के प्रति देय राशि बिना उलझन के ट्रैक करें।',
    svc3Title: 'रिमाइंडर',
    svc3Desc: 'महत्वपूर्ण भुगतान तिथियों से पहले समय पर अलर्ट।',
    svc4Title: 'रिपोर्ट',
    svc4Desc: 'धन प्रवाह और बाकी की स्पष्ट रिपोर्ट।',
    svc5Title: 'सुरक्षित सिंक',
    svc5Desc: 'फ़ोन + वेब, हमेशा सिंक में एक ही निजी खाता।',
    svc6Title: 'भाषाएँ',
    svc6Desc: 'हर उपयोगकर्ता के लिए अंग्रेज़ी, हिंदी और गुजराती तैयार।',

    reviewsEyebrow: 'समीक्षाएँ',
    reviewsTitle: 'रोज़मर्रा के पर्सनल हिसाब के लिए हज़ारों का भरोसा',
    reviewsText: 'अपने पर्सनल जमा, उधार और रोज़ाना पैसे के रिकॉर्ड को सरल, सुरक्षित और स्मार्ट डिजिटल खाते के साथ व्यवस्थित रखें।',
    rev1Text: 'आखिरकार एक प्रीमियम खाता ऐप। ग्राहकों से उधार ट्रैक करना इतना आसान कभी नहीं था।',
    rev1Name: 'अनannya S.',
    rev1Place: 'अहमदाबाद',
    rev2Text: 'रिमाइंडर वास्तव में समय पर वसूली में मदद करते हैं। मेरा बकाया काफी कम हो गया।',
    rev2Name: 'राहुल M.',
    rev2Place: 'मुंबई',
    rev3Text: 'बिल्कुल स्पष्ट डिज़ाइन। अब मुझे हर सुबह अपनी दुकान का खाता देखना अच्छा लगता है।',
    rev3Name: 'प्रिया N.',
    rev3Place: 'सूरत',
    rev4Text: 'अंतरराष्ट्रीय गुणवत्ता का ऐप — भारतीय दुकानदारों और व्यापारियों के लिए बिल्कुल सही।',
    rev4Name: 'करण P.',
    rev4Place: 'पुणे',

    blogEyebrow: 'हमारा नवीनतम ब्लॉग',
    blogTitle: 'स्मार्ट खाता के लिए गाइड',
    blogText: 'क्रेडिट, डेबिट, वसूली और व्यवसाय वृद्धि पर संक्षिप्त लेख।',
    blog1Title: 'स्वस्थ व्यवसायिक क्रेडिट के 5 आदत',
    blog1Meta: '4 मिनट पढ़ें',
    blog1Tag: 'टिप्स',
    blog2Title: 'बिना तनाव के उधार कैसे ट्रैक करें',
    blog2Meta: '5 मिनट पढ़ें',
    blog2Tag: 'गाइड',
    blog3Title: 'खाता ऐप में सुरक्षा क्यों ज़रूरी है',
    blog3Meta: '6 मिनट पढ़ें',
    blog3Tag: 'विश्वास',
    readMore: 'और पढ़ें',

    ctaTitle: 'अपना रोज़ाना हिसाब सरल बनाने के लिए तैयार हैं?',
    ctaText: 'VEVAROK के AI-संचालित डिजिटल खाते के साथ हर लेन-देन रिकॉर्ड करें, बैलेंस ट्रैक करें, और कोई भी भुगतान कभी न भूलें।',
    createAccount: 'मुफ़्त खाता बनाएँ',
    talkToUs: 'हमसे बात करें',
    liveSupportFab: 'लाइव सपोर्ट',
    liveSupportTitle: 'VEVAROK लाइव सपोर्ट',
    liveSupportOnline: 'अभी ऑनलाइन',
    liveSupportText: 'अपने डिजिटल खाते में मदद चाहिए? तुरंत चैट करें या Softwagon टीम से जुड़ें।',
    liveSupportWhatsapp: 'WhatsApp चैट',
    liveSupportWhatsappSub: 'WhatsApp पर त्वरित जवाब',
    liveSupportCall: 'कॉल सपोर्ट',
    liveSupportEmail: 'ईमेल करें',
    liveSupportForm: 'संपर्क फ़ॉर्म',
    liveSupportFormSub: 'विस्तृत संदेश भेजें',

    footerAbout: 'दुकानदारों और व्यापारियों के लिए डिजिटल खाता — प्रीमियम, सुरक्षित और सुंदर रूप से सरल। Softwagon Technologies Pvt. Ltd. का ब्रांड।',
    phone: 'फ़ोन',
    email: 'ईमेल',
    address: 'पता',

    aboutPageEyebrow: 'हमारे बारे में',
    aboutPageTitle: 'VEVAROK – Softwagon Technologies का आपका पर्सनल डिजिटल खाता',
    aboutPageSub: 'VEVAROK एक AI-संचालित पर्सनल क्रेडिट और डेबिट ऐप है जो जमा, उधार, रोज़ाना खर्च और पर्सनल हिसाब को सरल बनाने के लिए बनाया गया है। डिजिटल खाता, AI वॉइस एंट्री, पेमेंट रिमाइंडर और सुरक्षित क्लाउड बैकअप के साथ, VEVAROK हर पर्सनल लेन-देन को व्यवस्थित, सटीक और कभी भी उपलब्ध रखने में मदद करता है।',
    aboutIntroTitle: 'पर्सनल क्रेडिट और डेबिट प्रबंधन को सरल, स्मार्ट और सुरक्षित बनाना',
    aboutIntroP1: 'VEVAROK, Softwagon Technologies Pvt. Ltd. का उत्पाद, 2026 में सभी के लिए पर्सनल क्रेडिट और डेबिट प्रबंधन आसान बनाने के विज़न के साथ लॉन्च हुआ। चाहे आप जमा, उधार, दोस्तों को उधार दिए पैसे, पारिवारिक लेन-देन या रोज़ाना व्यक्तिगत खर्च ट्रैक कर रहे हों — VEVAROK सब कुछ एक सुरक्षित डिजिटल खाते में व्यवस्थित रखने में मदद करता है।',
    aboutIntroP2: 'AI वॉइस एंट्री, स्मार्ट पेमेंट रिमाइंडर, पार्टी-वार लेन-देन इतिहास और क्लाउड बैकअप जैसी स्मार्ट सुविधाओं के साथ आपका रोज़ाना हिसाब तेज़, अधिक सटीक और पूरी तरह पेपरलेस हो जाता है। Android, iPhone और Web पर उपलब्ध, VEVAROK सुनिश्चित करता है कि आपके पर्सनल वित्तीय रिकॉर्ड हमेशा सुलभ, सुरक्षित और अप टू डेट रहें।',
    missionTitle: 'हमारा मिशन',
    missionText: 'हमारा मिशन है लोगों को आसान डिजिटल खाते के माध्यम से पर्सनल क्रेडिट, डेबिट, जमा, उधार और रोज़ाना वित्तीय रिकॉर्ड आत्मविश्वास से प्रबंधित करने में मदद करना। हम AI-संचालित सुविधाओं, सुरक्षित क्लाउड स्टोरेज और स्मार्ट पेमेंट रिमाइंडर के साथ रोज़मर्रा की पैसे ट्रैकिंग सरल बनाना चाहते हैं।',
    visionTitle: 'हमारी दृष्टि',
    visionText: 'हमारी दृष्टि है व्यक्तियों के लिए पसंदीदा पर्सनल क्रेडिट और डेबिट ऐप बनना — एक सुरक्षित, इंटेलिजेंट और विश्वसनीय प्लेटफ़ॉर्म प्रदान करके जो पर्सनल पैसे के रिकॉर्ड प्रबंधन को सरल, सटीक और पूरी तरह पेपरलेस बनाता है।',
    valuesTitle: 'हमारे मूल्य',
    valuesText: 'VEVAROK की हर सुविधा विश्वास, गोपनीयता, सरलता और नवाचार के मूल्यों पर बनी है। हम एक सुरक्षित डिजिटल खाता बनाने के लिए समर्पित हैं जो उपयोगकर्ताओं को आत्मविश्वास से पर्सनल वित्तीय रिकॉर्ड प्रबंधित करने में मदद करे, साथ ही आधुनिक तकनीक से संचालित सहज अनुभव दे।',
    benefitsEyebrow: 'लाभ',
    benefitsTitle: 'अपने रोज़ाना पर्सनल हिसाब के लिए VEVAROK क्यों चुनें',
    benefitsText: 'आत्मविश्वास के साथ अपना जमा, उधार, क्रेडिट और डेबिट प्रबंधित करें। VEVAROK AI-संचालित सुविधाओं, सुरक्षित क्लाउड स्टोरेज और सहज डिजिटल खाते को जोड़कर पर्सनल पैसे प्रबंधन को सरल, व्यवस्थित और तनाव-मुक्त बनाता है।',
    benefit1: 'पूर्ण स्पष्टता के साथ पर्सनल क्रेडिट और डेबिट ट्रैक करें',
    benefit2: 'हर जमा और उधार रिकॉर्ड के लिए सुरक्षित डिजिटल खाता',
    benefit3: 'स्मार्ट रिमाइंडर के साथ कोई भुगतान न चूकें',
    benefit4: 'पूरा पर्सनल लेन-देन इतिहास और रिपोर्ट देखें',
    benefit5: 'कभी भी Android, iPhone और Web पर सिंक करें',
    benefit6: 'VEVAROK को अंग्रेज़ी, हिंदी और गुजराती में उपयोग करें',

    servicesPageEyebrow: 'हमारी सेवाएँ',
    servicesPageTitle: 'आसान पर्सनल क्रेडिट और डेबिट प्रबंधन के लिए स्मार्ट सुविधाएँ',
    servicesPageSub: 'VEVAROK आपको AI-संचालित डिजिटल खाते के साथ जमा, उधार, पर्सनल क्रेडिट और डेबिट, रोज़ाना खर्च और पेमेंट रिमाइंडर प्रबंधित करने में मदद करता है। रोज़मर्रा के पर्सनल पैसे प्रबंधन को सरल बनाने के लिए शक्तिशाली सुविधाएँ देखें।',
    svc7Title: 'एंट्री इतिहास',
    svc7Desc: 'पिछली निपटान खोजें और हर व्यवसायिक लेनदेन दोबारा देखें।',
    svc8Title: 'गोपनीयता नियंत्रण',
    svc8Desc: 'एन्क्रिप्शन-प्रथम डिज़ाइन के साथ आपका डेटा सुरक्षित रहता है।',
    svc9Title: 'मल्टी-डिवाइस एक्सेस',
    svc9Desc: 'Android, iPhone और Web के बीच आसानी से स्विच करें — आपका डेटा सिंक रहता है।',
    svc10Title: 'डिजिटल मनी डायरी',
    svc10Desc: 'अपने सभी पर्सनल पैसे के रिकॉर्ड एक सुरक्षित डिजिटल खाते में व्यवस्थित रखें, कभी भी उपलब्ध।',

    contactPageEyebrow: 'संपर्क करें',
    contactPageTitle: 'आइए बात करें',
    contactPageSub: 'VEVAROK पर डिजिटल खाता के बारे में प्रश्न? हम सुन रहे हैं।',
    contactDetails: 'संपर्क विवरण',
    contactDetailsText: 'उत्पाद सहायता, प्रतिक्रिया या साझेदारी प्रश्नों के लिए हमारी सहायता टीम से संपर्क करें।',
    sendMessage: 'संदेश भेजें',
    fullName: 'पूरा नाम',
    yourName: 'आपका नाम',
    yourEmail: 'you@email.com',
    yourPhone: '+91 ...',
    message: 'संदेश',
    howCanHelp: 'हम कैसे मदद कर सकते हैं?',
    sendBtn: 'संदेश भेजें',
    sendingBtn: 'भेजा जा रहा है...',
    thankMsg: 'धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे।',
    contactSubmitError: 'आपका संदेश नहीं भेजा जा सका। कृपया फिर से प्रयास करें।',
    captchaRequired: 'कृपया भेजने से पहले CAPTCHA सत्यापन पूरा करें।',
    captchaError: 'CAPTCHA सत्यापन असफल रहा। कृपया फिर से प्रयास करें।',
    captchaLoadError: 'CAPTCHA लोड नहीं हो सका। कृपया पेज रिफ्रेश करके फिर कोशिश करें।',
    captchaConfigError: 'CAPTCHA कॉन्फ़िगर नहीं है। कृपया साइट व्यवस्थापक से संपर्क करें।',

    supportPageEyebrow: 'सहायता',
    supportPageTitle: 'हम मदद के लिए यहाँ हैं',
    supportPageSub: 'VEVAROK पर डिजिटल खाता और क्रेडिट-डेबिट के बारे में त्वरित उत्तर पाएँ।',
    faqTitle: 'अक्सर पूछे जाने वाले प्रश्न',
    aboutFaqTitle: 'VEVAROK के बारे में उत्तर पाएँ',
    faqText: 'VEVAROK के साथ अपने पर्सनल क्रेडिट और डेबिट, जमा-उधार और डिजिटल खाता प्रबंधन के बारे में वह सब जो आपको जानना चाहिए।',
    contactSupport: 'सहायता से संपर्क',
    faq1Q: 'VEVAROK क्या है?',
    faq1A: 'VEVAROK एक AI-संचालित पर्सनल क्रेडिट और डेबिट ऐप है जो आपको जमा, उधार, रोज़ाना खर्च और पर्सनल पैसे के रिकॉर्ड एक सुरक्षित डिजिटल खाते में प्रबंधित करने में मदद करता है।',
    faq2Q: 'VEVAROK कौन उपयोग कर सकता है?',
    faq2A: 'VEVAROK किसी भी व्यक्ति के लिए है जो पर्सनल वित्तीय रिकॉर्ड प्रबंधित करना चाहता है — दोस्त, परिवार, रूममेट्स और वे लोग जो नियमित रूप से दिए या लिए गए पैसे ट्रैक करते हैं।',
    faq3Q: 'क्या मैं आवाज़ से लेन-देन रिकॉर्ड कर सकता/सकती हूँ?',
    faq3A: 'हाँ। VEVAROK में AI वॉइस एंट्री है, जिससे आप बोलकर क्रेडिट और डेबिट लेन-देन रिकॉर्ड कर सकते हैं।',
    faq4Q: 'क्या मैं कई डिवाइस पर VEVAROK एक्सेस कर सकता/सकती हूँ?',
    faq4A: 'हाँ। आप Android, iPhone और Web से सुरक्षित रूप से अपना डिजिटल खाता एक्सेस कर सकते हैं, और आपका डेटा सभी डिवाइस पर सिंक रहता है।',
    faq5Q: 'क्या VEVAROK कई भाषाओं का समर्थन करता है?',
    faq5A: 'हाँ। सहज अनुभव के लिए VEVAROK अंग्रेज़ी, हिंदी और गुजराती में उपलब्ध है।',
    faq6Q: 'सहायता से कैसे संपर्क करें?',
    faq6A: 'संपर्क पेज पर जाएँ या support@vevarok.com पर ईमेल करें। Softwagon Technologies की टीम मदद के लिए तैयार है।',

    authRegisterTitle: 'अपना खाता बनाएँ',
    authRegisterText: 'एक स्पष्ट डिजिटल खाता में क्रेडिट और डेबिट ट्रैक करें।',
    authLoginTitle: 'वापस स्वागत है',
    authLoginText: 'अपने क्रेडिट और डेबिट डैशबोर्ड तक पहुँचें।',
    authForgotTitle: 'पासवर्ड रीसेट',
    authForgotText: 'अपना ईमेल दर्ज करें, हम पहचान सत्यापित करने के लिए एक बार का कोड भेजेंगे।',
    authOtpTitle: 'OTP दर्ज करें',
    authOtpText: 'हमने आपके ईमेल पर 4 अंकों का कोड भेजा है। जारी रखने के लिए नीचे दर्ज करें।',
    name: 'पूरा नाम',
    password: 'पासवर्ड',
    confirmPassword: 'पासवर्ड की पुष्टि',
    forgotPassword: 'पासवर्ड भूल गए?',
    sendOtp: 'OTP भेजें',
    verify: 'सत्यापित करें',
    alreadyHave: 'पहले से खाता है?',
    noAccount: 'VEVAROK पर नए हैं?',
    blogPageEyebrow: 'ब्लॉग',
    blogPageTitle: 'हमारे नए लेख',
    blogPageSub: 'क्रेडिट, डेबिट, वसूली और व्यापार वृद्धि के व्यावहारिक गाइड।',
    blog4Title: 'रिमाइंडर का स्मार्ट उपयोग',
    blog4Meta: '4 मिनट पढ़ें',
    blog4Tag: 'प्रोडक्ट',
    blog4Excerpt: 'ड्यू-डेट अलर्ट को बेहतर वसूली की आदत बनाएँ।',
    blog1Excerpt: 'सरल आदतें जो क्रेडिट एंट्री साफ़ और तनाव-मुक्त रखें।',
    blog2Excerpt: 'बकाया और भुगतान तारीखों को शांति से संभालने का तरीका।',
    blog3Excerpt: 'आपके डिजिटल खाते के लिए एन्क्रिप्शन और गोपनीयता का अर्थ।',
    readArticle: 'लेख पढ़ें',
    backToLogin: 'साइन इन पर वापस',
    secureSignIn: 'सुरक्षित साइन इन',
    continueBtn: 'जारी रखें',
    signIn: 'साइन इन',
    createPassword: 'मज़बूत पासवर्ड बनाएँ',
    yourPassword: 'आपका पासवर्ड'
  },
  gu: {
    home: 'હોમ',
    about: 'અમારા વિશે',
    services: 'સેવાઓ',
    blog: 'બ્લોગ',
    support: 'સપોર્ટ',
    contact: 'સંપર્ક',
    registerLogin: 'રજિસ્ટર / લૉગિન',
    language: 'ભાષા',
    viewMore: 'વધુ જુઓ',
    getStarted: 'શરૂ કરો',
    learnMore: 'વધુ જાણો',
    login: 'લૉગિન',
    register: 'રજિસ્ટર',
    downloadApp: 'એપ ડાઉનલોડ',
    pricing: 'કિંમત',
    faq: 'FAQ',
    privacy: 'ગોપનીયતા',
    terms: 'નિયમો',
    termsAndConditions: 'નિયમો અને શરતો',
    privacyPolicy: 'ગોપનીયતા નીતિ',
    accountDeletion: 'એકાઉન્ટ ડિલીશન',
    product: 'ઉત્પાદન',
    company: 'કંપની',
    legal: 'કાયદાકીય',
    quickLinks: 'ઝડપી લિંક',
    help: 'મદદ',
    allRights: 'સર્વાધિકાર સુરક્ષિત.',
    comingSoon: 'ટૂંક સમયમાં',
    pillarsEyebrow: 'અમે કોણ છીએ',
    purposeEyebrow: 'હેતુ',
    pillarsTitle: 'મિશન, વિઝન અને મૂલ્યો',
    pillarsText: 'દરેકને આત્મવિશ્વાસ સાથે પર્સનલ પૈસા મેનેજ કરવા માટે સશક્ત બનાવવું',
    digitalKhata: 'ડિજિટલ ખાતું',
    addressCity: 'A-611 SIGNATURE-2, SARKHEJ SANAND HIGHWAY, Sarkhej, Daskroi, Ahmedabad - 382210, Gujarat',

    slide1Title: 'તમારા વ્યક્તિગત ક્રેડિટ અને ડેબિટ રેકોર્ડ મેનેજ કરવાની સૌથી સ્માર્ટ રીત',
    slide1Subtitle: 'VEVAROK સાથે દરેક જમા અને ઉધાર ટ્રેક કરો',
    slide1Text: 'VEVAROK એ AI-સંચાલિત ડિજિટલ ખાતું અને પર્સનલ ક્રેડિટ ડેબિટ એપ છે જે તમને આપેલા પૈસા, મળેલા પૈસા, રોજિંદા ખર્ચ અને બાકી ચુકવણીઓ એક સુરક્ષિત સ્થાને રેકોર્ડ કરવામાં મદદ કરે છે. કાગળની નોટબુકની જગ્યાએ સ્માર્ટ રિમાઇન્ડર, રિપોર્ટ અને વૉઇસ એન્ટ્રી અપનાવો.',
    slide1Cta: 'મફત શરૂ કરો',
    webBase: 'વેબ બેઝ',
    slide1Badge: 'એન્ક્રિપ્ટેડ ખાતું',
    slide1PhoneLabel: 'શુભ સાંજ',
    slide1FloatATitle: 'ક્રેડિટ એન્ટ્રી',
    slide1FloatASub: '+₹4,500 · આરવ',
    slide1FloatBTitle: 'ડેબિટ બાકી',
    slide1FloatBSub: '₹2,800 · કાલે',
    slide1FloatCTitle: 'રિમાઇન્ડર',
    slide1FloatCSub: 'પ્રિયા પાસેથી વસૂલી',
    slide1FloatDTitle: 'વિશ્લેષણ',
    slide1FloatDSub: 'આ મહિને +18%',
    slide1Row1: 'નેહા · ક્રેડિટ',
    slide1Row2: 'ભાડું · ડેબિટ',
    credit: 'ક્રેડિટ',
    debit: 'ડેબિટ',

    slide2Title: 'દરેક ગ્રાહક, મિત્ર અને પરિવારના ખાતાને વિગતવાર રિપોર્ટ સાથે ટ્રેક કરો',
    slide2Text: 'દરેક વ્યક્તિ માટે સંપૂર્ણ વ્યવહાર ઇતિહાસ, બાકી બેલેન્સ, ચુકવણી રિમાઇન્ડર, વસૂલી અને ડાઉનલોડ કરી શકાય તેવી રિપોર્ટ જુઓ. રિયલ-ટાઇમ ખાતા સારાંશ સાથે વ્યવસ્થિત રહો અને ક્યારેય તમારી જમા અથવા ઉધાર ગુમાવશો નહીં.',
    slide2Cta: 'સેવાઓ જુઓ',
    slide2Badge: 'સ્માર્ટ રિપોર્ટ',
    slide2PhoneLabel: 'બાકી',
    slide2FloatATitle: 'પાર્ટી રિપોર્ટ',
    slide2FloatASub: '42 સક્રિય પાર્ટીઓ',
    slide2FloatBTitle: 'વસૂલી',
    slide2FloatBSub: 'આજે ₹18,200',
    slide2FloatCTitle: 'રિમાઇન્ડર',
    slide2FloatCSub: '5 બાકી બાકી',
    slide2FloatDTitle: 'વૃદ્ધિ',
    slide2FloatDSub: 'વસૂલી +24%',
    slide2Row1: 'રમેશ ટ્રેડર્સ',
    slide2Row2: 'કિરણ સ્ટોર',

    slide3Title: 'એક ખાતું. Android, iPhone અને Web—હંમેશા સિંકમાં',
    slide3Text: 'કોઈપણ ડિવાઇસથી તમારું સંપૂર્ણ વ્યક્તિગત ખાતું મેનેજ કરો. Android, iOS અને Web પર રિયલ-ટાઇમ અપડેટ સાથે સુરક્ષિત ક્લાઉડ-સિંક રેકોર્ડ ક્યારેય, ગમે ત્યાં એક્સેસ કરો.',
    slide3Cta: 'એકાઉન્ટ બનાવો',
    slide3Badge: 'મલ્ટી પ્લેટફોર્મ',
    slide3PhoneLabel: 'સિંક અને સુરક્ષિત',
    slide3FloatATitle: 'સુરક્ષા ઢાળ',
    slide3FloatASub: 'બેંક-સ્તરની ગોપનીયતા',
    slide3FloatBTitle: 'વેબ એક્સેસ',
    slide3FloatBSub: 'vevarok.com',
    slide3FloatCTitle: 'એપ સ્ટોર',
    slide3FloatCSub: 'iOS તૈયાર',
    slide3FloatDTitle: 'પ્લે સ્ટોર',
    slide3FloatDSub: 'Android તૈયાર',
    slide3Row1: 'ક્લાઉડ સિંક',
    slide3Row2: 'ડિવાઇસ',

    heroBrand: 'VEVAROK · Softwagon Technologies',
    seeServices: 'અમારી સેવાઓ',
    encrypted: 'એન્ક્રિપ્ટેડ',
    multiLang: 'EN · HI · GU',
    multiPlatform: 'Android · iOS · Web',

    aboutEyebrow: 'અમારા વિશે',
    aboutTitle: 'પર્સનલ ક્રેડિટ અને ડેબિટ મેનેજમેન્ટને સરળ, સ્માર્ટ અને સુરક્ષિત બનાવવું',
    aboutBody: 'VEVAROK, Softwagon Technologies Pvt. Ltd. નું પ્રોડક્ટ, 2026 માં દરેક માટે પર્સનલ ક્રેડિટ અને ડેબિટ મેનેજમેન્ટ સરળ બનાવવાના વિઝન સાથે લોન્ચ થયું. તમે જમા, ઉધાર, મિત્રોને આપેલા પૈસા, પારિવારિક વ્યવહારો કે રોજિંદા વ્યક્તિગત ખર્ચ ટ્રેક કરતા હો — VEVAROK બધું એક સુરક્ષિત ડિજિટલ ખાતામાં વ્યવસ્થિત રાખવામાં મદદ કરે છે.',
    aboutLi1: 'પર્સનલ ક્રેડિટ અને ડેબિટ વ્યવહારો સરળતાથી રેકોર્ડ કરો',
    aboutLi2: 'જમા, ઉધાર અને રોજિંદા પર્સનલ હિસાબ ટ્રેક કરો',
    aboutLi3: 'ઝડપી વ્યવહાર રેકોર્ડિંગ માટે AI વૉઇસ એન્ટ્રી',
    aboutLi4: 'સ્માર્ટ પેમેન્ટ રિમાઇન્ડર નોટિફિકેશન',
    aboutLi5: 'પાર્ટી-વાર વ્યવહાર ઇતિહાસ અને બેલેન્સ રિપોર્ટ',
    aboutLi6: 'Android, iOS અને Web પર ઉપલબ્ધ',

    getAppEyebrow: 'એપ મેળવો',
    getAppTitle: 'VEVAROK ક્યાંય પણ ડાઉનલોડ કરો',
    getAppText: 'કોઈપણ ડિવાઇસથી તમારા પર્સનલ ક્રેડિટ અને ડેબિટ, ગ્રાહક ખાતા, રોજિંદા ખર્ચ અને ચુકવણી રેકોર્ડ મેનેજ કરો. સુરક્ષિત ક્લાઉડ સિંક સાથે Android, iOS અને Web પર જોડાયેલા રહો.',
    getOn: 'ડાઉનલોડ કરો',
    googlePlay: 'Google Play',
    downloadOn: 'ડાઉનલોડ કરો',
    appStore: 'App Store',
    alsoOn: 'અહીં પણ ઉપલબ્ધ',
    webApp: 'વેબ એપ',

    whyEyebrow: 'અમને કેમ પસંદ કરો',
    whyTitle: 'ડિજિટલ ફાઇનાન્શિયલ રેકોર્ડ',
    whyText: 'તમામ જમા, ઉધાર, ક્રેડિટ અને ડેબિટના વ્યવહારોને એક જ સુરક્ષિત જગ્યાએ મેનેજ કરો. રોજિંદા ઉપયોગ માટે તૈયાર કરાયેલ સ્માર્ટ ડિજિટલ ખાતા-બહી સાથે તમારો દરેક હિસાબ સરળ, સુરક્ષિત અને વ્યવસ્થિત રાખો.',
    why1Title: 'બેંક-સ્તરની સુરક્ષા',
    why1Desc: 'તમારા વ્યવસાયિક ડેટા માટે સંપૂર્ણ ગોપનીયતા સાથે એન્ક્રિપ્ટેડ ખાતા એન્ટ્રી.',
    why2Title: 'ક્રેડિટ સ્પષ્ટતા',
    why2Desc: 'કોને કેટલું બાકી છે તે જાણો — એક નજરમાં.',
    why3Title: 'ડેબિટ નિયંત્રણ',
    why3Desc: 'સપ્લાયર અને ગ્રાહકો પ્રતિ દેવાયેલી રકમ શાંત રિમાઇન્ડર સાથે ટ્રેક કરો.',
    why4Title: 'સ્માર્ટ વિશ્લેષણ',
    why4Desc: 'વસૂલી વધારવા અને બાકી ઘટાડવામાં મદદ કરતું વિશ્લેષણ.',

    showcaseEyebrow: 'AI સંચાલિત ખાતું',
    showcaseTitle: 'બોલીને એન્ટ્રી કરો — AI તરત સમજે',
    showcaseText: 'VEVAROK સ્માર્ટ AI સહાયક તમારો અવાજ સાંભળે છે, રકમ ઓળખે છે અને ક્રેડિટ-ડેબિટ ખાતું સેકંડોમાં અપડેટ કરે છે.',
    showcaseLi1: 'AI વૉઇસ એન્ટ્રી — બોલીને ક્રેડિટ અને ડેબિટ ઉમેરો',
    showcaseLi2: 'સ્માર્ટ AI સહાયક — પાર્ટી, રકમ, નોંધ ઑટો-ફિલ',
    showcaseLi3: 'હિંદી, અંગ્રેજી અને ગુજરાતી વૉઇસ સપોર્ટ',
    aiVoiceTitle: 'AI વૉઇસ એન્ટ્રી',
    aiVoiceDesc: 'બોલીને ક્રેડિટ અને ડેબિટ ઉમેરો — AI તરત રકમ, નામ અને નોંધ સમજે છે.',
    smartAiTitle: 'સ્માર્ટ AI સહાયક',
    smartAiDesc: 'વૉઇસ પછી AI પાર્ટી, રકમ અને રિમાઇન્ડર ઑટો-ફિલ કરે છે — લગભગ ટાઇપિંગ વગર.',
    listening: 'સાંભળી રહ્યું છે…',
    aiParsed: 'AI પાર્સ કર્યું',
    voice: 'વૉઇસ',
    ai: 'AI',
    happyUsers: 'ખુશ વપરાશકર્તાઓ',
    entriesTracked: 'ટ્રેક થયેલી એન્ટ્રી',
    appRating: 'એપ રેટિંગ',

    experienceEyebrow: 'VEVAROK અનુભવ',
    personTitle: 'તમારું ડિજિટલ ખાતું સાથી',
    personText: 'VEVAROK સાથે તમારા રોજિંદા નાણાંકીય વ્યવસ્થાપનનો સ્માર્ટ રસ્તો અનુભવો. પરંપરાગત કાગળના ખાતાઓની જગ્યાએ આધુનિક ડિજિટલ ખાતું અપનાવો જે દરેક ક્રેડિટ, ડેબિટ અને ચુકવણી રેકોર્ડને એક સુરક્ષિત સ્થાને વ્યવસ્થિત રાખે છે. ઝડપી વ્યવહાર રેકોર્ડિંગ માટે AI વૉઇસ એન્ટ્રી વાપરો, પાર્ટી-વાર રિપોર્ટથી બાકી બેલેન્સ મોનિટર કરો, પેમેન્ટ રિમાઇન્ડર ઓટોમેટ કરો, અને ક્લાઉડ સિંક સાથે ક્યારેય પણ સુરક્ષિત રીતે તમારા ડેટા સુધી પહોંચો. તમે ઘરે હો, દુકાનમાં હો કે મુસાફરીમાં — VEVAROK ખાતરી કરે છે કે તમારું સંપૂર્ણ હિસાબ-કિતાબ હંમેશા સચોટ અને ઉપલબ્ધ રહે.',

    servicesEyebrow: 'સેવાઓ',
    servicesTitle: 'રોજિંદા પૈસા વ્યવસ્થાપન માટે ઑલ-ઇન-વન ડિજિટલ ખાતું',
    servicesText: 'દરેક ક્રેડિટ અને ડેબિટ વ્યવહારને સરળતાથી રેકોર્ડ, ટ્રેક અને મેનેજ કરવામાં મદદ કરવા માટે બનાવેલું.',
    svc1Title: 'ક્રેડિટ એન્ટ્રી',
    svc1Desc: 'નોંધ અને તારીખો સાથે ગ્રાહક ક્રેડિટ દાખલ અને નિપટાવો.',
    svc2Title: 'ડેબિટ એન્ટ્રી',
    svc2Desc: 'માનસિક બોજ વિના સપ્લાયરોને ચૂકવવાપાત્ર રકમનો હિસાબ રાખો.',
    svc3Title: 'રિમાઇન્ડર',
    svc3Desc: 'મહત્વપૂર્ણ ચુકવણી તારીખો પહેલાં સમયસર એલર્ટ.',
    svc4Title: 'રિપોર્ટ',
    svc4Desc: 'ધન પ્રવાહ અને બાકીની સ્પષ્ટ રિપોર્ટ.',
    svc5Title: 'સુરક્ષિત સિંક',
    svc5Desc: 'ફોન + વેબ, હંમેશા સિંકમાં એ જ ખાનગી ખાતું.',
    svc6Title: 'ભાષાઓ',
    svc6Desc: 'દરેક વપરાશકર્તા માટે અંગ્રેજી, હિંદી અને ગુજરાતી તૈયાર.',

    reviewsEyebrow: 'સમીક્ષાઓ',
    reviewsTitle: 'રોજિંદા પર્સનલ હિસાબ માટે હજારોનો વિશ્વાસ',
    reviewsText: 'તમારા પર્સનલ જમા, ઉધાર અને રોજિંદા પૈસાના રેકોર્ડને સરળ, સુરક્ષિત અને સ્માર્ટ ડિજિટલ ખાતા સાથે વ્યવસ્થિત રાખો.',
    rev1Text: 'અંતે એક પ્રીમિયમ ખાતા એપ. ગ્રાહકો પાસેથી ઉધાર ટ્રેક કરવું આટલું સરળ ક્યારેય નહોતું.',
    rev1Name: 'અનannya S.',
    rev1Place: 'અમદાવાદ',
    rev2Text: 'રિમાઇન્ડર ખરેખર સમયસર વસૂલીમાં મદદ કરે છે. મારું બાકી ઘણું ઘટી ગયું.',
    rev2Name: 'રાહુલ M.',
    rev2Place: 'મુંબઈ',
    rev3Text: 'એકદમ સ્પષ્ટ ડિઝાઇન. હવે મને દર સવારે મારી દુકાનનું ખાતું જોવું ગમે છે.',
    rev3Name: 'પ્રિયા N.',
    rev3Place: 'સુરત',
    rev4Text: 'આંતરરાષ્ટ્રીય ગુણવત્તાનું એપ — ભારતીય દુકાનદારો અને વેપારીઓ માટે બિલકુલ યોગ્ય.',
    rev4Name: 'કરણ P.',
    rev4Place: 'પુણે',

    blogEyebrow: 'અમારો નવીનતમ બ્લોગ',
    blogTitle: 'સ્માર્ટ ખાતા માટે માર્ગદર્શન',
    blogText: 'ક્રેડિટ, ડેબિટ, વસૂલી અને વ્યવસાય વૃદ્ધિ પર ટૂંકા લેખ.',
    blog1Title: 'સ્વસ્થ વ્યવસાયિક ક્રેડિટની 5 આદતો',
    blog1Meta: '4 મિનિટ વાંચો',
    blog1Tag: 'ટિપ્સ',
    blog2Title: 'તણાવ વગર ઉધાર કેવી રીતે ટ્રેક કરવું',
    blog2Meta: '5 મિનિટ વાંચો',
    blog2Tag: 'માર્ગદર્શન',
    blog3Title: 'ખાતા એપમાં સુરક્ષા શા માટે જરૂરી',
    blog3Meta: '6 મિનિટ વાંચો',
    blog3Tag: 'વિશ્વાસ',
    readMore: 'વધુ વાંચો',

    ctaTitle: 'તમારું રોજિંદું હિસાબ સરળ બનાવવા તૈયાર છો?',
    ctaText: 'VEVAROK ના AI-સંચાલિત ડિજિટલ ખાતા સાથે દરેક વ્યવહાર રેકોર્ડ કરો, બેલેન્સ ટ્રેક કરો, અને કોઈપણ ચુકવણી ક્યારેય ભૂલશો નહીં.',
    createAccount: 'મફત એકાઉન્ટ બનાવો',
    talkToUs: 'અમારી સાથે વાત કરો',
    liveSupportFab: 'લાઇવ સપોર્ટ',
    liveSupportTitle: 'VEVAROK લાઇવ સપોર્ટ',
    liveSupportOnline: 'હમણાં ઑનલાઇન',
    liveSupportText: 'તમારા ડિજિટલ ખાતામાં મદદ જોઈએ? તરત ચેટ કરો અથવા Softwagon ટીમ સાથે જોડાઓ.',
    liveSupportWhatsapp: 'WhatsApp ચેટ',
    liveSupportWhatsappSub: 'WhatsApp પર ઝડપી જવાબ',
    liveSupportCall: 'કૉલ સપોર્ટ',
    liveSupportEmail: 'ઇમેઇલ કરો',
    liveSupportForm: 'સંપર્ક ફોર્મ',
    liveSupportFormSub: 'વિગતવાર સંદેશ મોકલો',

    footerAbout: 'દુકાનદારો અને વેપારીઓ માટે ડિજિટલ ખાતું — પ્રીમિયમ, સુરક્ષિત અને સુંદર રીતે સરળ. Softwagon Technologies Pvt. Ltd. નું બ્રાન્ડ.',
    phone: 'ફોન',
    email: 'ઇમેઇલ',
    address: 'સરનામું',

    aboutPageEyebrow: 'અમારા વિશે',
    aboutPageTitle: 'VEVAROK – Softwagon Technologies નું તમારું પર્સનલ ડિજિટલ ખાતું',
    aboutPageSub: 'VEVAROK એ AI-સંચાલિત પર્સનલ ક્રેડિટ અને ડેબિટ એપ છે જે જમા, ઉધાર, રોજિંદા ખર્ચ અને પર્સનલ હિસાબને સરળ બનાવવા માટે બનાવવામાં આવી છે. ડિજિટલ ખાતું, AI વૉઇસ એન્ટ્રી, પેમેન્ટ રિમાઇન્ડર અને સુરક્ષિત ક્લાઉડ બેકઅપ સાથે, VEVAROK દરેક પર્સનલ વ્યવહારને વ્યવસ્થિત, સચોટ અને ક્યારેય પણ ઉપલબ્ધ રાખવામાં મદદ કરે છે.',
    aboutIntroTitle: 'પર્સનલ ક્રેડિટ અને ડેબિટ મેનેજમેન્ટને સરળ, સ્માર્ટ અને સુરક્ષિત બનાવવું',
    aboutIntroP1: 'VEVAROK, Softwagon Technologies Pvt. Ltd. નું પ્રોડક્ટ, 2026 માં દરેક માટે પર્સનલ ક્રેડિટ અને ડેબિટ મેનેજમેન્ટ સરળ બનાવવાના વિઝન સાથે લોન્ચ થયું. તમે જમા, ઉધાર, મિત્રોને આપેલા પૈસા, પારિવારિક વ્યવહારો કે રોજિંદા વ્યક્તિગત ખર્ચ ટ્રેક કરતા હો — VEVAROK બધું એક સુરક્ષિત ડિજિટલ ખાતામાં વ્યવસ્થિત રાખવામાં મદદ કરે છે.',
    aboutIntroP2: 'AI વૉઇસ એન્ટ્રી, સ્માર્ટ પેમેન્ટ રિમાઇન્ડર, પાર્ટી-વાર વ્યવહાર ઇતિહાસ અને ક્લાઉડ બેકઅપ જેવી સ્માર્ટ સુવિધાઓ સાથે તમારું રોજિંદું હિસાબ ઝડપી, વધુ સચોટ અને સંપૂર્ણ પેપરલેસ બને છે. Android, iPhone અને Web પર ઉપલબ્ધ, VEVAROK ખાતરી કરે છે કે તમારા પર્સનલ નાણાકીય રેકોર્ડ હંમેશા સુલભ, સુરક્ષિત અને અપ ટુ ડેટ રહે.',
    missionTitle: 'અમારું મિશન',
    missionText: 'અમારું મિશન છે લોકોને સરળ ડિજિટલ ખાતા દ્વારા પર્સનલ ક્રેડિટ, ડેબિટ, જમા, ઉધાર અને રોજિંદા નાણાકીય રેકોર્ડ આત્મવિશ્વાસથી મેનેજ કરવામાં મદદ કરવી. અમે AI-સંચાલિત સુવિધાઓ, સુરક્ષિત ક્લાઉડ સ્ટોરેજ અને સ્માર્ટ પેમેન્ટ રિમાઇન્ડર સાથે રોજિંદી પૈસા ટ્રેકિંગ સરળ બનાવવા માંગીએ છીએ.',
    visionTitle: 'અમારું વિઝન',
    visionText: 'અમારું વિઝન છે વ્યક્તિઓ માટે પસંદગીનું પર્સનલ ક્રેડિટ અને ડેબિટ એપ બનવું — એક સુરક્ષિત, ઇન્ટેલિજન્ટ અને વિશ્વસનીય પ્લેટફોર્મ પૂરું પાડીને જે પર્સનલ પૈસાના રેકોર્ડ મેનેજમેન્ટને સરળ, સચોટ અને સંપૂર્ણ પેપરલેસ બનાવે.',
    valuesTitle: 'અમારા મૂલ્યો',
    valuesText: 'VEVAROK ની દરેક સુવિધા વિશ્વાસ, ગોપનીયતા, સરળતા અને નવીનતાના મૂલ્યો પર બનેલી છે. અમે એક સુરક્ષિત ડિજિટલ ખાતું બનાવવા માટે સમર્પિત છીએ જે વપરાશકર્તાઓને આત્મવિશ્વાસથી પર્સનલ નાણાકીય રેકોર્ડ મેનેજ કરવામાં મદદ કરે, સાથે આધુનિક ટેકનોલોજીથી સંચાલિત સહજ અનુભવ આપે.',
    benefitsEyebrow: 'લાભ',
    benefitsTitle: 'તમારા રોજિંદા પર્સનલ હિસાબ માટે VEVAROK કેમ પસંદ કરો',
    benefitsText: 'આત્મવિશ્વાસ સાથે તમારું જમા, ઉધાર, ક્રેડિટ અને ડેબિટ મેનેજ કરો. VEVAROK AI-સંચાલિત સુવિધાઓ, સુરક્ષિત ક્લાઉડ સ્ટોરેજ અને સહજ ડિજિટલ ખાતાને જોડીને પર્સનલ પૈસા મેનેજમેન્ટને સરળ, વ્યવસ્થિત અને તણાવ-મુક્ત બનાવે છે.',
    benefit1: 'સંપૂર્ણ સ્પષ્ટતા સાથે પર્સનલ ક્રેડિટ અને ડેબિટ ટ્રેક કરો',
    benefit2: 'દરેક જમા અને ઉધાર રેકોર્ડ માટે સુરક્ષિત ડિજિટલ ખાતું',
    benefit3: 'સ્માર્ટ રિમાઇન્ડર સાથે કોઈ ચુકવણી ચૂકશો નહીં',
    benefit4: 'સંપૂર્ણ પર્સનલ વ્યવહાર ઇતિહાસ અને રિપોર્ટ જુઓ',
    benefit5: 'ક્યારેય પણ Android, iPhone અને Web પર સિંક કરો',
    benefit6: 'VEVAROK ને અંગ્રેજી, હિંદી અને ગુજરાતીમાં વાપરો',

    servicesPageEyebrow: 'અમારી સેવાઓ',
    servicesPageTitle: 'સરળ પર્સનલ ક્રેડિટ અને ડેબિટ મેનેજમેન્ટ માટે સ્માર્ટ સુવિધાઓ',
    servicesPageSub: 'VEVAROK તમને AI-સંચાલિત ડિજિટલ ખાતા સાથે જમા, ઉધાર, પર્સનલ ક્રેડિટ અને ડેબિટ, રોજિંદા ખર્ચ અને પેમેન્ટ રિમાઇન્ડર મેનેજ કરવામાં મદદ કરે છે. રોજિંદા પર્સનલ પૈસા મેનેજમેન્ટને સરળ બનાવવા માટે શક્તિશાળી સુવિધાઓ જુઓ.',
    svc7Title: 'એન્ટ્રી ઇતિહાસ',
    svc7Desc: 'ભૂતકાળની નિપટાણ શોધો અને દરેક વ્યવસાયિક વ્યવહાર ફરી જુઓ.',
    svc8Title: 'ગોપનીયતા નિયંત્રણ',
    svc8Desc: 'એન્ક્રિપ્શન-પ્રથમ ડિઝાઇન સાથે તમારો ડેટા સુરક્ષિત રહે છે.',
    svc9Title: 'મલ્ટી-ડિવાઇસ એક્સેસ',
    svc9Desc: 'Android, iPhone અને Web વચ્ચે સરળતાથી સ્વિચ કરો — તમારો ડેટા સિંક રહે છે.',
    svc10Title: 'ડિજિટલ મની ડાયરી',
    svc10Desc: 'તમારા બધા પર્સનલ પૈસાના રેકોર્ડ એક સુરક્ષિત ડિજિટલ ખાતામાં વ્યવસ્થિત રાખો, ક્યારેય પણ ઉપલબ્ધ.',

    contactPageEyebrow: 'સંપર્ક',
    contactPageTitle: 'ચાલો વાત કરીએ',
    contactPageSub: 'VEVAROK પર ડિજિટલ ખાતા વિશે પ્રશ્નો? અમે સાંભળી રહ્યા છીએ.',
    contactDetails: 'સંપર્ક વિગતો',
    contactDetailsText: 'ઉત્પાદન સહાય, પ્રતિસાદ અથવા ભાગીદારી પ્રશ્નો માટે અમારી સપોર્ટ ટીમનો સંપર્ક કરો.',
    sendMessage: 'સંદેશ મોકલો',
    fullName: 'પૂરું નામ',
    yourName: 'તમારું નામ',
    yourEmail: 'you@email.com',
    yourPhone: '+91 ...',
    message: 'સંદેશ',
    howCanHelp: 'અમે કેવી રીતે મદદ કરી શકીએ?',
    sendBtn: 'સંદેશ મોકલો',
    sendingBtn: 'મોકલી રહ્યા છીએ...',
    thankMsg: 'આભાર! અમે ટૂંક સમયમાં તમારો સંપર્ક કરીશું.',
    contactSubmitError: 'તમારો સંદેશ મોકલી શકાયો નહીં. કૃપા કરીને ફરી પ્રયાસ કરો.',
    captchaRequired: 'કૃપા કરીને મોકલતા પહેલાં CAPTCHA ચકાસણી પૂર્ણ કરો.',
    captchaError: 'CAPTCHA ચકાસણી નિષ્ફળ થઈ. કૃપા કરીને ફરી પ્રયાસ કરો.',
    captchaLoadError: 'CAPTCHA લોડ થઈ શક્યું નહીં. કૃપા કરીને પેજ રિફ્રેશ કરીને ફરી પ્રયાસ કરો.',
    captchaConfigError: 'CAPTCHA ગોઠવાયેલ નથી. કૃપા કરીને સાઇટ એડમિનિસ્ટ્રેટરનો સંપર્ક કરો.',

    supportPageEyebrow: 'સપોર્ટ',
    supportPageTitle: 'અમે મદદ માટે અહીં છીએ',
    supportPageSub: 'VEVAROK પર ડિજિટલ ખાતા અને ક્રેડિટ-ડેબિટ વિશે ઝડપી જવાબ મેળવો.',
    faqTitle: 'વારંવાર પૂછાતા પ્રશ્નો',
    aboutFaqTitle: 'VEVAROK વિશે જવાબ મેળવો',
    faqText: 'VEVAROK સાથે તમારા પર્સનલ ક્રેડિટ અને ડેબિટ, જમા-ઉધાર અને ડિજિટલ ખાતા મેનેજમેન્ટ વિશે જે જાણવું જોઈએ તે બધું.',
    contactSupport: 'સપોર્ટનો સંપર્ક',
    faq1Q: 'VEVAROK શું છે?',
    faq1A: 'VEVAROK એ AI-સંચાલિત પર્સનલ ક્રેડિટ અને ડેબિટ એપ છે જે તમને જમા, ઉધાર, રોજિંદા ખર્ચ અને પર્સનલ પૈસાના રેકોર્ડ એક સુરક્ષિત ડિજિટલ ખાતામાં મેનેજ કરવામાં મદદ કરે છે.',
    faq2Q: 'VEVAROK કોણ વાપરી શકે?',
    faq2A: 'VEVAROK કોઈપણ માટે છે જે પર્સનલ નાણાકીય રેકોર્ડ મેનેજ કરવા માંગે — મિત્રો, પરિવાર, રૂમમેટ્સ અને જે લોકો નિયમિત આપેલા કે મળેલા પૈસા ટ્રેક કરે છે.',
    faq3Q: 'શું હું અવાજથી વ્યવહાર રેકોર્ડ કરી શકું?',
    faq3A: 'હા. VEVAROK માં AI વૉઇસ એન્ટ્રી છે, જેનાથી તમે બોલીને ક્રેડિટ અને ડેબિટ વ્યવહારો રેકોર્ડ કરી શકો.',
    faq4Q: 'શું હું અનેક ડિવાઇસ પર VEVAROK એક્સેસ કરી શકું?',
    faq4A: 'હા. તમે Android, iPhone અને Web થી સુરક્ષિત રીતે તમારું ડિજિટલ ખાતું એક્સેસ કરી શકો, અને તમારો ડેટા બધા ડિવાઇસ પર સિંક રહે છે.',
    faq5Q: 'શું VEVAROK અનેક ભાષાઓ સપોર્ટ કરે છે?',
    faq5A: 'હા. આરામદાયક અનુભવ માટે VEVAROK અંગ્રેજી, હિંદી અને ગુજરાતીમાં ઉપલબ્ધ છે.',
    faq6Q: 'સપોર્ટનો સંપર્ક કેવી રીતે કરવો?',
    faq6A: 'સંપર્ક પેજ પર જાઓ અથવા support@vevarok.com પર ઇમેઇલ કરો. Softwagon Technologies ની ટીમ મદદ માટે તૈયાર છે.',

    authRegisterTitle: 'તમારું એકાઉન્ટ બનાવો',
    authRegisterText: 'એક સ્પષ્ટ ડિજિટલ ખાતામાં ક્રેડિટ અને ડેબિટ ટ્રેક કરો.',
    authLoginTitle: 'પાછા આવકાર',
    authLoginText: 'તમારા ક્રેડિટ અને ડેબિટ ડેશબોર્ડ ઍક્સેસ કરો.',
    authForgotTitle: 'પાસવર્ડ રીસેટ',
    authForgotText: 'તમારું ઇમેઇલ દાખલ કરો, અમે ઓળખ ચકાસવા માટે એક વખતનો કોડ મોકલીશું.',
    authOtpTitle: 'OTP દાખલ કરો',
    authOtpText: 'અમે તમારા ઇમેઇલ પર 4 અંકનો કોડ મોકલ્યો છે. ચાલુ રાખવા નીચે દાખલ કરો.',
    name: 'પૂરું નામ',
    password: 'પાસવર્ડ',
    confirmPassword: 'પાસવર્ડની પુષ્ટિ',
    forgotPassword: 'પાસવર્ડ ભૂલી ગયા?',
    sendOtp: 'OTP મોકલો',
    verify: 'ચકાસો',
    alreadyHave: 'પહેલેથી એકાઉન્ટ છે?',
    noAccount: 'VEVAROK પર નવા છો?',
    blogPageEyebrow: 'બ્લોગ',
    blogPageTitle: 'અમારા નવા લેખો',
    blogPageSub: 'ક્રેડિટ, ડેબિટ, વસૂલાત અને વ્યવસાય વૃદ્ધિ માટે વ્યવહારિક માર્ગદર્શિકાઓ.',
    blog4Title: 'રિમાઇન્ડરનો સ્માર્ટ ઉપયોગ',
    blog4Meta: '4 મિનિટ વાંચો',
    blog4Tag: 'પ્રોડક્ટ',
    blog4Excerpt: 'ડ્યૂ-ડેટ અલર્ટને સારી વસૂલાતની આદત બનાવો.',
    blog1Excerpt: 'સરળ આદતો જે ક્રેડિટ એન્ટ્રી સ્પષ્ટ અને તણાવમુક્ત રાખે.',
    blog2Excerpt: 'બાકી અને ચુકવણી તારીખોને શાંતિથી સંભાળવાની રીત.',
    blog3Excerpt: 'તમારા ડિજિટલ ખાતા માટે એન્ક્રિપ્શન અને ગોપનીયતાનો અર્થ.',
    readArticle: 'લેખ વાંચો',
    backToLogin: 'સાઇન ઇન પર પાછા',
    secureSignIn: 'સુરક્ષિત સાઇન ઇન',
    continueBtn: 'ચાલુ રાખો',
    signIn: 'સાઇન ઇન',
    createPassword: 'મજબૂત પાસવર્ડ બનાવો',
    yourPassword: 'તમારો પાસવર્ડ'
  }
};
